import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const ShopPage = () => {
    return (
        <Container maxWidth="lg">
            <Box sx={{ my: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom>
                    Shop Resources
                </Typography>
                <Typography variant="body1">
                    Purchase Starter Packs, Genius Boxes, and Educational Kits.
                    {/* TODO: Implement product grid and cart */}
                </Typography>
            </Box>
        </Container>
    );
};

export default ShopPage;
